"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarAlert = exports.SnackbarAlertCtaButton = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const CheckCircle_1 = require("@mui/icons-material/CheckCircle");
const Close_1 = require("@mui/icons-material/Close");
const Info_1 = require("@mui/icons-material/Info");
const Warning_1 = require("@mui/icons-material/Warning");
const material_1 = require("@mui/material");
// need to apply severity to button to match expected color for the button
// unfortunately severity is not a pop on button by default
function SnackbarAlertCtaButton(props) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({}, props, { variant: "text", size: "large", 
        // default is success to match mui default alert when no severity defined
        color: (_a = props.severity) !== null && _a !== void 0 ? _a : 'success', style: { padding: '2px 4px' } }, { children: props.children }), void 0));
}
exports.SnackbarAlertCtaButton = SnackbarAlertCtaButton;
function SnackbarAlert(props) {
    const { alertProps } = props, snackbarProps = (0, tslib_1.__rest)(props, ["alertProps"]);
    // only used when both action and close icon exist
    // otherwise close icon is default out-of-box from Alert render
    const close = ((0, jsx_runtime_1.jsx)(material_1.IconButton, Object.assign({ color: "inherit", onClick: alertProps === null || alertProps === void 0 ? void 0 : alertProps.onClose, size: "small", "aria-label": "Close", title: "Close", type: "button" }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, { fontSize: "small" }, void 0) }), void 0));
    // override in order to show action and close at the same time
    // by default action replaces close, even if onClose passed into Alert prop
    const action = (alertProps === null || alertProps === void 0 ? void 0 : alertProps.action) ? ((0, jsx_runtime_1.jsxs)(material_1.Stack, Object.assign({ flexDirection: "row", justifyContent: "center" }, { children: [alertProps.action, (alertProps === null || alertProps === void 0 ? void 0 : alertProps.onClose) ? close : null] }), void 0)) : undefined;
    return ((0, jsx_runtime_1.jsx)(material_1.Snackbar, Object.assign({ "data-qa": 'atom-component__snackbar-wrapper' }, snackbarProps, { children: (0, jsx_runtime_1.jsx)(material_1.Alert, Object.assign({}, alertProps, { action: action, iconMapping: {
                error: (0, jsx_runtime_1.jsx)(Info_1.default, {}, void 0),
                info: (0, jsx_runtime_1.jsx)(Info_1.default, {}, void 0),
                success: (0, jsx_runtime_1.jsx)(CheckCircle_1.default, {}, void 0),
                warning: (0, jsx_runtime_1.jsx)(Warning_1.default, {}, void 0),
            }, elevation: 2, 
            // match default icon size
            sx: { lineHeight: '24px' } }, { children: props.message }), void 0) }), void 0));
}
exports.SnackbarAlert = SnackbarAlert;
//# sourceMappingURL=snackbar.js.map